<template>
<div
  class="draggable-wrapper"
>
</div>
</template>

<script setup>
</script>

<style lang="scss" scoped>
.draggable-wrapper {
  height: 100%;
  cursor: grab;
  background-image: radial-gradient(rgba(163, 142, 254, 0.5333333333) 28%, transparent 0%);
  background-position: 11px 12px;
  background-size: 10px 10px;
  opacity: 0.5;
}
</style>
